const init = () => {
    document.querySelectorAll( '.component-slider' ).forEach( element => {
        const items = element.querySelectorAll( '.component-slider__item' )
        const previous_button = element.querySelector( '.component-slider__previous' )
        const next_button = element.querySelector( '.component-slider__next' )
        const autoplay_button = element.querySelector('.component-slider__autoplay')

        let current = 0
        let autoplay = true
        let interval = null

        const show = index => {
            items.forEach( item => item.classList.remove( 'active' ) )
            items[index].classList.add( 'active' )
        }

        show( current )

        previous_button.addEventListener( 'click', () => {
            current = current === 0 ? items.length - 1 : current - 1
            show( current )
        } )

        next_button.addEventListener( 'click', () => {
            current = current === items.length - 1 ? 0 : current + 1
            show( current )
        } )

        const playSVG = '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.5 15V3L14.5 9L5.5 15Z" stroke="currentColor" stroke-width="2"/></svg>'
        const pauseSVG = '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 16H6V2H8V16ZM12 16H10V2H12V16Z" fill="currentColor"/></svg>'

        const updateAutoplayButton = () => {
            if (autoplay_button) {
                autoplay_button.innerHTML = autoplay ? pauseSVG : playSVG
                autoplay_button.setAttribute('aria-label', autoplay ? 'Pause' : 'Lecture')
            }
        }

        const startAutoplay = () => {
            if (interval) clearInterval(interval)
            interval = setInterval(() => {
                current = current === items.length - 1 ? 0 : current + 1
                show(current)
            }, 3000)
        }

        const stopAutoplay = () => {
            if (interval) clearInterval(interval)
            interval = null
        }

        if (autoplay_button) {
            autoplay_button.addEventListener('click', () => {
                autoplay = !autoplay
                updateAutoplayButton()
                if (autoplay) {
                    startAutoplay()
                } else {
                    stopAutoplay()
                }
            })
            updateAutoplayButton()
        }

        if (autoplay) {
            startAutoplay()
        }
    } )
}

document.addEventListener( 'ContentLoaded', init )
document.addEventListener( 'NewContentLoaded', init )
